import { Descriptions } from "@/components/v2";
import { type DescriptionsProps } from "antd";
import { Driver } from "@rumble-it/common-lib/types/models/Driver.interface";
import { getMapsLink } from "@/lib/helpers/links";
import { Card } from "@rumbledirect/ui";

interface DriverCardProps {
  driver: Driver | undefined;
  isLoading: boolean;
}

export const DriverCard = ({ driver, isLoading }: DriverCardProps) => {
  const items: DescriptionsProps["items"] = [
    {
      label: "Naam",
      children: driver?.person?.fullName,
    },
    {
      label: "E-mailadres",
      children: driver?.person?.email ? (
        <a href={`mailto:${driver.person.email}`}>{driver.person.email}</a>
      ) : null,
    },
    {
      label: "Telefoonnummer",
      children: driver?.person?.telephone ? (
        <a href={`tel:${driver.person.telephone}`}>{driver.person.telephone}</a>
      ) : null,
    },
    {
      label: "Adres",
      //TODO: Use address component
      children: driver?.address ? (
        <>
          <a
            href={getMapsLink({ address: driver.address })}
            target="_blank"
            rel="noopener noreferrer"
          >
            {`${driver.address.street} ${driver.address.streetNumber}${driver.address.streetNumberAddition || ""}`}{" "}
            <br />
            {driver.address.postalCode} {driver.address.city}{" "}
            {driver.address.country ? (
              <>
                <br />
                {driver.address.country}
              </>
            ) : null}
          </a>
        </>
      ) : null,
    },
  ];

  return (
    <Card loading={isLoading} className="w-full" title="Bestuurder">
      <Descriptions items={items} />
    </Card>
  );
};
